// And underscore (_) represenstts a forward slash (/) or hyphen (-)
type PublicRouteKey = '_login' | '_no_access'
type PublicRoutesMap = { [key in PublicRouteKey]: string }

export const PUBLIC_PAGE_ROUTES: PublicRoutesMap = {
  _login: '/login',
  _no_access: '/no-access',
}
